<footer class="w-full bg-[#DCE8FA]">

  <div
    class="mx-auto flex min-h-[38px] max-w-full flex-col
           justify-between gap-6 px-6 py-5
           sm:px-8
           md:flex-row md:items-center md:gap-8
           lg:px-12"
  >

    <!-- Energia Branding -->
    <div class="flex flex-col">

      <span
        class="text-xl font-bold tracking-wide text-[#1F2FA3]"
      >
        ENERGIA
      </span>

      <span
        class="mt-1 text-[14px] font-normal text-gray-500"
      >
        © Proud Channel Partner of Mensa India.
      </span>

    </div>


    <!-- Footer Navigation -->
    <nav
      class="flex flex-wrap items-center gap-x-8 gap-y-3
             text-[16px] text-gray-500
             sm:gap-x-10
             md:justify-end"
    >

      <a
        routerLink="/terms-and-conditions"
        class="transition-colors duration-200
               hover:text-[#1F2FA3]"
      >
        Terms of Conditions
      </a>

      <a
        routerLink="/privacy-policy"
        class="transition-colors duration-200
               hover:text-[#1F2FA3]"
      >
        Privacy Policy
      </a>

    </nav>

  </div>

</footer>
